// extracted by mini-css-extract-plugin
module.exports = {"dot-flashing":"_base-dots-anim_dot-flashing_3swy6"};